import { Nullable } from '@kts-front/types';

import { LotApartmentAttributesServer, LotApartmentLayoutType } from '../types';

export type LotApartmentAttributes = {
  layoutType: Nullable<LotApartmentLayoutType>;
  cardinalDirections: Nullable<string>;
  windowView: Nullable<string>;
  /**
   * Не путать с `section` в модели лота (там текущий "Корпус", отдельная сущность) — это другое поле,
   * пришедшее из Profitbase, оба называются "section" на разных уровнях API.
   */
  section: Nullable<string>;
};

export const layoutTypeTextMap: Record<Exclude<LotApartmentLayoutType, LotApartmentLayoutType.unknown>, string> = {
  [LotApartmentLayoutType.euro]: 'Европланировка',
  [LotApartmentLayoutType.studio]: 'Студия',
  [LotApartmentLayoutType.none]: 'Типовая',
};

export const mapLotApartmentAttributes = (raw: LotApartmentAttributesServer): LotApartmentAttributes => ({
  layoutType: raw.layout_type,
  cardinalDirections: raw.cardinal_directions,
  windowView: raw.window_view ? raw.window_view.charAt(0).toUpperCase() + raw.window_view.slice(1).toLowerCase() : null,
  section: raw.section,
});
